module.exports = __webpack_public_path__ + "pc/img/04_Brand-Identity.3e1a653c.png";